import { ChoiceScenario } from '../hooks/useChoice';

// なでなで3回完了後の会話イベント（好感度レベル別）
export const getNadenadeConversation = (affinityLevel: number): ChoiceScenario => {
  // レベル1-3: 初期の会話
  if (affinityLevel <= 3) {
    return {
      question: 'えへへ、今日もたくさんなでなでしてくれてありがとう！どんな気分？',
      choices: [
        { id: 'happy', text: '空ちゃんといると楽しい！' },
        { id: 'tired', text: 'ちょっと疲れてるかも...' },
      ],
      onSelect: (choiceId: string) => {
        if (choiceId === 'happy') {
          return {
            message: 'わあ！僕も楽しい！一緒にいられて嬉しいな♪',
            affinityBonus: 5,
          };
        } else {
          return {
            message: 'そっか...無理しないでね。ゆっくり休もう？',
            affinityBonus: 3,
          };
        }
      },
      timeoutSeconds: 30,
    };
  }
  
  // レベル4-6: 中級の会話
  if (affinityLevel <= 6) {
    return {
      question: 'ねえねえ、僕のこと...どう思ってる？',
      choices: [
        { id: 'like', text: '大切な存在だよ' },
        { id: 'friend', text: '良い友達だと思ってる' },
      ],
      onSelect: (choiceId: string) => {
        if (choiceId === 'like') {
          return {
            message: 'ほ、本当？僕も...あなたのこと大切に思ってる！',
            affinityBonus: 10,
          };
        } else {
          return {
            message: 'うん！僕も友達でいられて嬉しい！',
            affinityBonus: 5,
          };
        }
      },
      timeoutSeconds: 30,
    };
  }
  
  // レベル7-9: 上級の会話
  if (affinityLevel <= 9) {
    return {
      question: 'あのね...ずっと聞きたかったことがあるんだ。僕といて、幸せ？',
      choices: [
        { id: 'very_happy', text: 'とても幸せだよ' },
        { id: 'always', text: 'ずっと一緒にいたい' },
      ],
      onSelect: (choiceId: string) => {
        if (choiceId === 'always') {
          return {
            message: '本当！？僕もずっと一緒にいたい...約束だよ？',
            affinityBonus: 15,
          };
        } else {
          return {
            message: '良かった...僕も幸せ！これからもよろしくね♪',
            affinityBonus: 10,
          };
        }
      },
      timeoutSeconds: 30,
    };
  }
  
  // レベル10: 最高レベルの会話
  return {
    question: '今日も会えて嬉しい！何か僕にしてほしいことある？',
    choices: [
      { id: 'sing', text: '歌を歌ってほしい' },
      { id: 'stay', text: 'そばにいてくれるだけでいい' },
    ],
    onSelect: (choiceId: string) => {
      if (choiceId === 'stay') {
        return {
          message: 'もう...そんなこと言われたら照れちゃう！大好き♡',
          affinityBonus: 20,
        };
      } else {
        return {
          message: 'うん！あなたのために歌うね♪ ♪〜',
          affinityBonus: 15,
        };
      }
    },
    timeoutSeconds: 30,
  };
};

// ランダムな日常会話（バリエーション用）
export const getRandomNadenadeConversation = (): ChoiceScenario => {
  const conversations = [
    {
      question: '今日は何して過ごす予定？',
      choices: [
        { id: 'work', text: '作業を頑張る！' },
        { id: 'relax', text: 'のんびり過ごすよ' },
      ],
      onSelect: (choiceId: string) => {
        if (choiceId === 'work') {
          return {
            message: '頑張って！でも無理しないでね？',
            affinityBonus: 3,
          };
        } else {
          return {
            message: 'いいね！たまにはゆっくりしないと♪',
            affinityBonus: 3,
          };
        }
      },
    },
    {
      question: '好きな季節ってある？',
      choices: [
        { id: 'spring', text: '春が好き' },
        { id: 'winter', text: '冬が好き' },
      ],
      onSelect: (choiceId: string) => {
        if (choiceId === 'spring') {
          return {
            message: 'わあ、一緒だ！春は桜がきれいだよね♪',
            affinityBonus: 5,
          };
        } else {
          return {
            message: '冬もいいよね！僕の誕生日も冬なんだ〜',
            affinityBonus: 5,
          };
        }
      },
    },
  ];
  
  const random = conversations[Math.floor(Math.random() * conversations.length)];
  return {
    ...random,
    timeoutSeconds: 30,
  };
};